import React from 'react';

import {
    useDisclosure,
    Alert,
    AlertIcon,
    AlertTitle,
    AlertDescription,
    Box,
    CloseButton,
} from '@chakra-ui/react';
import { PrismicRichText } from '@prismicio/react';
import { linkResolver } from '../../utils/linkResolver';

export default function SidewideAlert({ alert }) {

    const {
      isOpen: isVisible,
      onClose,
      onOpen,
    } = useDisclosure({ defaultIsOpen: true })
  
    return isVisible ? (
      <Box w="100%">
          <Alert status='error' bg="vintage-yellow.500" justifyContent="center" py="8">
            <AlertIcon />
            <Box>
              <AlertTitle className="alert-title" color="blue.600"> 
                <PrismicRichText field={alert.alert_content.richText} />
              </AlertTitle>
            </Box>
            <CloseButton
              alignSelf='flex-start'
              position='relative'
              right={-45}
              // top={-1}
              onClick={onClose}
              color="black"
            />
          </Alert>
      </Box>
    ) : (
      ""
    )
  }